import { Add, Remove } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  TextField,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const PickDiv = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "0.2fr 1fr 2fr 2fr 1fr 1fr 2fr 1fr",
  gap: "10px",
  margin: "10px 0",
  alignItems: "center",
  textAlign: "center",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
  },
  "& button": {
    textTransform: "none",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

const QuantityBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const PickupLine = ({
  pick,
  productQuantity,
  setProductQuantity,
  check,
  setCheck,
  handleChange,
  handleCheck,
  handleAddQuantity,
  handleRemoveQuantity,
}) => {


  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";
  }

  return (
    <PickDiv>
      <div>
        <Checkbox checked={check} onChange={handleCheck} />
      </div>
      <div>
        <img
          src={pick?.ax_relation?.imageUrl || "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"}
          alt={pick?.ax_relation?.ItemName}
          onError={handleImageError}
        />
      </div>
      <div>
        <p>{pick?.ax_relation?.ItemName}</p>
      </div>
      <div>
        <p>{pick?.code}</p>
      </div>
      <div>
        <p>{pick?.ax_relation?.SizeID}</p>
      </div>
      <div
        style={{
          background:
            parseInt(pick.quantity) == productQuantity ? "#d1ffbd" : "#ffcccb",
        }}
      >
        {parseInt(pick?.quantity)}
      </div>
      <div>
        <QuantityBox>
          <IconButton onClick={() => handleRemoveQuantity(pick)}>
            <Remove />
          </IconButton>
          <TextField
            name="quantity"
            type="number"
            variant="outlined"
            value={productQuantity === 0 ? 0 : productQuantity || 1}
            onChange={(e) => handleChange(e,pick)}
            style={{ width: "100px" }}
            InputProps={{
              inputProps: {
                max: parseInt(pick?.quantity),
                min: 0,
              },
            }}
          />
          <IconButton onClick={() => handleAddQuantity(pick)}>
            {" "}
            <Add />{" "}
          </IconButton>
        </QuantityBox>

        {/* <p>{pick?.quantity}</p> */}
      </div>
      <div>
        <Button variant="contained" color="primary">
          Picked
        </Button>
      </div>
    </PickDiv>
  );
};

export default PickupLine;
